import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
const icache = createICacheMiddleware();
const factory = create({ icache, theme }).properties();
export const Image = factory(({ properties, middleware: { icache } }) => {
    const { topicdata } = properties();
    const data = topicdata;
    const { attributes = { src: '#', id: '' }, children = [] } = data;
    const src = attributes.src;
    const width = icache.get('width');
    const styles = width ? { width: `${width}px`, height: 'auto' } : {};
    const alt = children
        .map((item) => {
        const key = Object.keys(item)[0];
        return item[key].children?.[0];
    })
        .join('');
    const params = { src, styles, alt };
    if (attributes.id) {
        params['aria-labelledby'] = `${attributes.id}_long_description`;
    }
    return v('img', {
        ...params,
        onload: (event) => {
            const img = event && event.currentTarget;
            img && icache.set('width', img.naturalWidth);
        }
    }, []);
});
